<template>
    <div>
        <form>
            <div class="form-group">
                <input class="form__input" type="file" @change="previewImage" accept="image/*"/>
                <label class="form__label up">Selecione uma imagem para subir</label>
            </div>
         
            <div v-if="imageData!=null">
                <p>Progresso: {{uploadValue.toFixed()+"%"}}
                    <progress id="progress" :value="uploadValue" max="100" ></progress>
                </p>
                <img class="preview" :src="picture" width="100%">
                <br>
            <button type="button" class="button" @click="onUpload()"><i class="ico-file_upload"></i> Enviar</button>
            </div>
        </form>
    </div>
</template>
<script>

export default {
    name: 'Upload',
    data(){
        return{
            fileData: {},
            imageData: null,
            picture: null,
            uploadValue: 0
        }
    },
    props:{
        callback: {
            type: Function
        }
    },
    methods:{
        previewImage(event) {
            this.uploadValue=0;
            this.picture=null;
            this.imageData = event.target.files[0];
            let data = event.target.files[0]
            this.fileData = {
                name: data.name,
                size: data.size,
                type: data.type,
                lastModified: data.lastModified,
                url: ''
            }
        },
        onUpload(){
            this.picture=null;
            const storageRef= this.$firebase.storage().ref(`${this.imageData.name}`).put(this.imageData);
            storageRef.on(`state_changed`, snapshot => {
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            },error => {
                console.error(error.message)
            },
            () => {
                this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                    this.picture = url
                    this.fileData.url = url
                    this.save()
                });
            });
        },
        save(){
            this.fileData.updatedOn = this.$moment().format('X')
            this.$db.collection('files').add(this.fileData).then(() => {
                alert('Arquivo salvo com sucesso.')
                this.callback()
            }).catch((err) => {
              console.log(err)
                alert('ocorreu um erro ao salvar o arquivo')
                this.loading = false
            })
        }

    }
}
</script>
<style>
img.preview {
    width: 200px;
}

</style>